/*eslint no-unreachable: "off"*/
/*eslint no-useless-concat: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint no-unused-vars: "off"*/
export function processForChart1(recordList) {
  let tmpChartRow;
  let NOW_LEG_DNR_CD = "";

  var tmpAry = new Array();

  for (var i = 0; i < recordList.length; ++i) {
    var item = recordList[i];

    if (i === 0) {
      tmpChartRow = new ChartRow();
      NOW_LEG_DNR_CD = item.LEG_DNR_CD;
      tmpChartRow.SM_TOTAL = 0;
    }

    if (NOW_LEG_DNR_CD !== item.LEG_DNR_CD) {
      tmpAry.push(tmpChartRow);
      tmpChartRow = new ChartRow();
      NOW_LEG_DNR_CD = item.LEG_DNR_CD;
      tmpChartRow.SM_TOTAL = 0;
    }

    tmpChartRow.LEG_DNR_CD = item.LEG_DNR_CD;
    tmpChartRow.LEG_DNR_NM = item.LEG_DNR_NM;

    switch (item.RAD_CLS_CD) {
      case "32":
        tmpChartRow.SM_32 = item.CNT;
        tmpChartRow.SM_32_str = insertComma(item.CNT);
        tmpChartRow.SM_TOTAL += Number(item.CNT);
        break;
      case "94":
        tmpChartRow.SM_94 = item.CNT;
        tmpChartRow.SM_94_str = insertComma(item.CNT);
        tmpChartRow.SM_TOTAL += Number(item.CNT);
        break;
      case "44":
        tmpChartRow.SM_44 = item.CNT;
        tmpChartRow.SM_44_str = insertComma(item.CNT);
        tmpChartRow.SM_TOTAL += Number(item.CNT);
        break;
      case "85":
        tmpChartRow.SM_85 = item.CNT;
        tmpChartRow.SM_85_str = insertComma(item.CNT);
        tmpChartRow.SM_TOTAL += Number(item.CNT);
        break;
      case "49":
        tmpChartRow.SM_49 = item.CNT;
        tmpChartRow.SM_49_str = insertComma(item.CNT);
        tmpChartRow.SM_TOTAL += Number(item.CNT);
        break;
      case "92":
        tmpChartRow.SM_92 = item.CNT;
        tmpChartRow.SM_92_str = insertComma(item.CNT);
        tmpChartRow.SM_TOTAL += Number(item.CNT);
        break;
      case "42":
        tmpChartRow.SM_42 = item.CNT;
        tmpChartRow.SM_42_str = insertComma(item.CNT);
        tmpChartRow.SM_TOTAL += Number(item.CNT);
        break;
      case "41":
        tmpChartRow.SM_41 = item.CNT;
        tmpChartRow.SM_41_str = insertComma(item.CNT);
        tmpChartRow.SM_TOTAL += Number(item.CNT);
        break;
      case "21":
        tmpChartRow.SM_21 = item.CNT;
        tmpChartRow.SM_21_str = insertComma(item.CNT);
        tmpChartRow.SM_TOTAL += Number(item.CNT);
        break;
      case "CMFL":
        tmpChartRow.SM_CMFL = item.CNT;
        tmpChartRow.SM_CMFL_str = insertComma(item.CNT);
        tmpChartRow.SM_TOTAL += Number(item.CNT);
        break;
      case "OTHER":
        tmpChartRow.SM_OTHER = item.CNT;
        tmpChartRow.SM_OTHER_str = insertComma(item.CNT);
        tmpChartRow.SM_TOTAL += Number(item.CNT);
        break;
      // no default
    }
  }

  if (recordList.length > 0) {
    tmpAry.push(tmpChartRow);
  }

  tmpAry.sort(function (a, b) {
    return a.SM_TOTAL < b.SM_TOTAL ? -1 : a.SM_TOTAL > b.SM_TOTAL ? 1 : 0;
  });

  return tmpAry;
}

export function processForChart2(recordList, searchChk) {
  let minYear = "";
  let maxYear = "";

  let tmpChartRow10YearC;
  let NOW_YEAR = "";
  let first = true;
  let secondMonth = ""; //월별로 조회시 전월대비용으로 가져온 전월데이터 제외한 다음 두번째달을 시작월로 표시하기위해

  let tmpAry10YearC = [];

  for (let i = 0; i < recordList.length; ++i) {
    const item = recordList[i];

    if (searchChk === "Y") {
      if (i === 0) {
        minYear = item.YEAR;
      }

      if (minYear < item.YEAR) {
        if (first) {
          tmpChartRow10YearC = new ChartRow();
          tmpChartRow10YearC.YEAR = item.YEAR;
          NOW_YEAR = item.YEAR;
          first = false;
        }

        if (NOW_YEAR !== item.YEAR) {
          tmpAry10YearC.push(tmpChartRow10YearC);
          tmpChartRow10YearC = new ChartRow();
          NOW_YEAR = item.YEAR;
          tmpChartRow10YearC.YEAR = item.YEAR;
        }

        tmpChartRow10YearC[`SM_${item.RAD_CLS_CD}`] = item.CNT;
        tmpChartRow10YearC[`SM_${item.RAD_CLS_CD}_str`] = insertComma(item.CNT);

        maxYear = item.YEAR;
      }
    } else {
      if (i === 0) {
        minYear = item.YEARMM;
      }

      if (minYear <= item.YEARMM) {
        if (first) {
          tmpChartRow10YearC = new ChartRow();
          tmpChartRow10YearC.YEAR = item.YEARMM;
          NOW_YEAR = item.YEARMM;
          first = false;
          secondMonth = item.YEARMM;
        }

        if (NOW_YEAR !== item.YEARMM) {
          tmpAry10YearC.push(tmpChartRow10YearC);
          tmpChartRow10YearC = new ChartRow();
          NOW_YEAR = item.YEARMM;
          tmpChartRow10YearC.YEAR = item.YEARMM;
        }

        tmpChartRow10YearC[`SM_${item.RAD_CLS_CD}`] = item.CNT;
        tmpChartRow10YearC[`SM_${item.RAD_CLS_CD}_str`] = insertComma(item.CNT);

        maxYear = item.YEARMM;
      }
    }
  }

  //minYear는 일단 계산하고나서 차트 상단 타이틀에 년도~ 표시할때는 +1하기 위해서
  if (searchChk === "Y") {
    minYear *= 1;
    minYear = minYear + 1;
  } else {
    minYear = secondMonth;
  }

  if (recordList.length > 0) tmpAry10YearC.push(tmpChartRow10YearC);

  return {
    minYear,
    maxYear,
    chart2Data: tmpAry10YearC,
  };
}

export function getChart1Layout(PRM_CHECK, PRM_CHECK_LABEL, searchEnd) {
  let title = searchEnd.substr(0, 4) + "년";
  // 스트링 형식으로 레이아웃 정의.
  let layout =
    '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">' +
    "<Options>" +
    '<Caption fontSize="19" text="국종별 무선국 수"/>' +
    //+'<Caption fontSize="19" text="국종별 무선국 수 &lt;a href=javascript:cartDownload(\'chart1\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a href=javascript:cartCsvDownloadcartId(\'chart1\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt;"/>'
    '<SubCaption textAlign="right" fontSize="15" paddingRight="10" paddingBottom="20" text="(' +
    title +
    ')"/>' +
    '<Legend position="bottom" hAlign="center" defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15" />' +
    "</Options>" +
    '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>' +
    '<Bar3DChart showDataTips="true" barWidthRatio="0.48">' +
    "<horizontalAxis>" +
    '<LinearAxis id="hAxis" formatter="{numfmt}" title="무선국 수" labelJsFunction="labelFuncNum"/>' +
    "</horizontalAxis>" +
    "<horizontalAxisRenderers>" +
    '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">' +
    "<axisStroke>" +
    '<Stroke weight="10" color="#f4f4f4"/>' +
    "</axisStroke>" +
    "<tickStroke>" +
    '<Stroke weight="1" color="#d2d2d2" alpha="1"/>' +
    "</tickStroke>" +
    "<minorTickStroke>" +
    '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>' +
    "</minorTickStroke>" +
    "</Axis3DRenderer>" +
    "</horizontalAxisRenderers>" +
    "<verticalAxis>" +
    '<CategoryAxis id="vAxis" categoryField="LEG_DNR_NM" title="지역" labelJsFunction="labelFunc2"/>' +
    "</verticalAxis>" +
    "<verticalAxisRenderers>" +
    '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="false" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">' +
    "<axisStroke>" +
    '<Stroke weight="10" color="#f4f4f4"/>' +
    "</axisStroke>" +
    "<tickStroke>" +
    '<Stroke weight="1" color="#d2d2d2" alpha="1"/>' +
    "</tickStroke>" +
    "<minorTickStroke>" +
    '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>' +
    "</minorTickStroke>" +
    "</Axis3DRenderer>" +
    "</verticalAxisRenderers>" +
    "<series>" +
    /*
  type 속성을 stacked로 변경
     type속성으로는
    clustered : 일반적인 다중데이터(차트의 멀티시리즈)방식으로 데이터를 표현합니다.(Default)
   stacked : 데이터를 위에 쌓아 올린 방식으로 표현 합니다.
     overlaid : 수치 데이터 값을 겹쳐서 표현 합니다. 주로 목표 위치와 현재 위치를 나타낼 때 많이 쓰입니다.
     100% : 차트의 수치 데이터를 퍼센티지로 계산 후 값을 퍼센티지로 나타냅니다.
   */
    '<Bar3DSet type="stacked" showTotalLabel="false" totalLabelJsFunction="totalFunc" color="#666" labelYOffset="-1" labelXOffset="5">' +
    "<series>";
  /* Bar2D Stacked 를 생성시에는 Bar2DSeries를 최소 2개 정의합니다 */
  layout += PRM_CHECK.map((prm, index) => {
    const displayName = PRM_CHECK_LABEL[index];
    return `
      <Bar3DSeries labelPosition="inside" showValueLabels="[]" xField="SM_${prm}" displayName="${displayName}" insideLabelYOffset="-2">
        <fill>
          <SolidColor color="${chartColor(displayName)}" />
        </fill>
        <showDataEffect>
          <SeriesInterpolate/>
        </showDataEffect>
      </Bar3DSeries>
    `;
  });

  layout +=
    "</series>" +
    "</Bar3DSet>" +
    "</series>" +
    "<annotationElements>" +
    '<CrossRangeZoomer zoomType="vertical" fontSize="14" horizontalLabelPlacement="left" horizontalLabelFormatter="{numfmt}" enableZooming="true" enableCrossHair="false">' +
    "</CrossRangeZoomer>" +
    "</annotationElements>" +
    "</Bar3DChart>" +
    "<Style>" +
    ".title{color : 0x4691E1;fontSize : 12;fontWeight : bold;}" +
    "</Style>" +
    "</rMateChart>";

  return layout;
}

export function getChart2Layout(
  PRM_CHECK,
  PRM_CHECK_LABEL,
  searchStart,
  searchEnd,
  searchChk
) {
  let title1 = "국종별 무선국 변동";
  let title2 = searchEnd.substr(0, 4) + "년";

  if (searchStart !== "" && searchEnd !== "") {
    title1 = "년간  국종별 무선국 변동";
    if (searchChk === "Y") {
      title2 = searchStart.substr(0, 4) + " ~ " + searchEnd.substr(0, 4) + "년";
    } else {
      if (searchStart !== searchEnd) {
        title2 =
          searchStart.substr(0, 4) + " ~ " + searchEnd.substr(0, 4) + "년";
      } else {
        title2 = searchEnd.substr(0, 4) + "년";
      }
    }
  }

  let layout =
    '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">' +
    "<Options>" +
    '<Caption fontSize="19" text="' +
    title1 +
    '  "/>' +
    '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' +
    title2 +
    ')"/>' +
    '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15"/>' +
    "</Options>" +
    '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>' +
    '<Column3DChart showDataTips="true" columnWidthRatio="0.4">' +
    "<horizontalAxis>" +
    '<CategoryAxis id="hAxis" categoryField="YEAR" title="변동 년도" labelJsFunction="chartLabelYear"/>' +
    "</horizontalAxis>" +
    "<horizontalAxisRenderers>" +
    '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">' +
    "<axisStroke>" +
    '<Stroke weight="10" color="#f4f4f4"/>' +
    "</axisStroke>" +
    "<tickStroke>" +
    '<Stroke weight="1" color="#d2d2d2" alpha="1"/>' +
    "</tickStroke>" +
    "<minorTickStroke>" +
    '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>' +
    "</minorTickStroke>" +
    "</Axis3DRenderer>" +
    "</horizontalAxisRenderers>" +
    "<verticalAxis>" +
    '<LinearAxis id="vAxis" formatter="{numfmt}" title="무선국수" labelJsFunction="labelFuncNum"/>' +
    "</verticalAxis>" +
    "<verticalAxisRenderers>" +
    '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">' +
    "<axisStroke>" +
    '<Stroke weight="10" color="#f4f4f4"/>' +
    "</axisStroke>" +
    "<tickStroke>" +
    '<Stroke weight="1" color="#d2d2d2" alpha="1"/>' +
    "</tickStroke>" +
    "<minorTickStroke>" +
    '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>' +
    "</minorTickStroke>" +
    "</Axis3DRenderer>" +
    "</verticalAxisRenderers>" +
    "<series>" +
    '<Column3DSet type="stacked" showTotalLabel="false" totalLabelJsFunction="totalFunc" labelYOffset="-5">' +
    "<series>";

  for (var i = 0; i < PRM_CHECK.length; i++) {
    layout +=
      '<Column3DSeries yField="SM_' +
      PRM_CHECK[i] +
      '" displayName="' +
      PRM_CHECK_LABEL[i] +
      '" lineToEachItems="true" showLinkLabels="false">' +
      /* lineToEachItems : True로 설정 하면 Series간에 선을 이어준다 */
      "<fill>" +
      '<SolidColor color="' +
      chartColor(PRM_CHECK_LABEL[i]) +
      '"/>' +
      "</fill>" +
      "<lineStroke>" +
      '<Stroke weight="1" color="#41b2e6"/>' +
      "</lineStroke>" +
      "<showDataEffect>" +
      "<SeriesInterpolate/>" +
      "</showDataEffect>" +
      "</Column3DSeries>";
  }

  layout +=
    "</series>" +
    "</Column3DSet>" +
    "</series>" +
    "</Column3DChart>" +
    "<Style>" +
    ".title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}" +
    "</Style>" +
    "</rMateChart>";

  return layout;
}

//숫자에 천단위 콤마 찍어 반환하는 함수.
function insertComma(n) {
  var reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n)) n = n.replace(reg, "$1" + "," + "$2");
  return n;
}

/////////////////////////////////////////////////////////////
// Chart 관련 작업 - 끝
/////////////////////////////////////////////////////////////

function ChartRow() {
  this.YEAR = null;
  this.LEG_DNR_CD = null;
  this.LEG_DNR_NM = null;
  this.SM_32 = null;
  this.SM_94 = null;
  this.SM_44 = null;
  this.SM_85 = null;
  this.SM_49 = null;
  this.SM_92 = null;
  this.SM_42 = null;
  this.SM_41 = null;
  this.SM_21 = null;
  this.SM_CMPL = null;
  this.SM_OTHER = null;
  this.SM_32_str = null;
  this.SM_94_str = null;
  this.SM_44_str = null;
  this.SM_85_str = null;
  this.SM_49_str = null;
  this.SM_92_str = null;
  this.SM_42_str = null;
  this.SM_41_str = null;
  this.SM_21_str = null;
  this.SM_CMPL_str = null;
  this.SM_OTHER_str = null;
}

function chartColor(displayName) {
  if (displayName.indexOf("간이무선국") > -1) return "#41b2e6";
  if (displayName.indexOf("고정국") > -1) return "#4452a8";
  if (displayName.indexOf("기지국") > -1) return "#fabc05";
  if (displayName.indexOf("선박국") > -1) return "#5587a2";
  if (displayName.indexOf("아마추어국") > -1) return "#69cabc";
  if (displayName.indexOf("육상이동국") > -1) return "#6c4a85";
  if (displayName.indexOf("의무선박국") > -1) return "#8a7860";
  if (displayName.indexOf("이동중계국") > -1) return "#f7a33b";
  if (displayName.indexOf("전파응용설비") > -1) return "#d8c6aa";
  if (displayName.indexOf("이동국") > -1) return "#68c0c9";
  if (displayName.indexOf("기타") > -1) return "#999999";
  if (displayName.indexOf("2G") > -1) return "#41b2e6";
  if (displayName.indexOf("3G") > -1) return "#4452a8";
  if (displayName.indexOf("LTE") > -1) return "#fabc05";
}
